<template>
  <div class="driver_detial">
    <div class="topSearch">
      <div class="innerSearch">
        <el-input placeholder="输入司机名称" v-model="driver_tool_search" class="input-with-select" id="topInput">
        </el-input>
      </div>
      <div style="margin: 8px">
        <el-button type="primary" @click="searchDriverToolHandle">搜索</el-button>
      </div>
    </div>
    <div class="log_table">
      <el-table
        :data="driver_log_data"
        style="width: 100%">
        <el-table-column
          prop="id"
          label="ID"
          width="100"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称"
          width="200"
        >
        </el-table-column>
        <el-table-column
          prop="worker_id"
          label="司机ID"
          width="350"
        >
        </el-table-column>
        <el-table-column
          prop="phone"
          label="手机号码"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="system"
          label="手机系统"
        >
        </el-table-column>

        <el-table-column
          prop="time"
          label="最后更新时间">
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <div class="action">
              <el-button type="primary" @click="showLogHanlde(scope.row)">当前位置</el-button>
              <el-button type="primary">测试消息推送</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="btomPagin" >
      <div class="innerLeft">{{page}} - <span>{{driver_log_data.length}}</span> of <span>{{total}}</span> items</div>
      <div>
        <el-pagination
          :page-size="10"
          layout="prev, pager, next, jumper"
          :total="total"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {getDriverLogList} from "@/api/toolBox";

export default {
  name: "driver_detial",
  data(){
    return{
      driver_tool_search:'',
      driver_log_data:[],
      page:1,
      total:'',
    }
  },
  created() {
    this.getLisrt()
  },
  methods:{
    getLisrt(){
      getDriverLogList({
        page:this.page,
        pageSize:10,
        searchContent:this.driver_tool_search
      }).then(res=>{
        this.driver_log_data = res.data
        this.total = res.total
      })
    },
    searchDriverToolHandle(){
      this.page = 1
      this.getLisrt()
    },
    handleCurrentChange(val){
      this.page = val
      this.getLisrt()
    },
    showLogHanlde(row){
      alert('司机当前位置：'+ row.latitude +',' + row.longitude);
    }
  }
}
</script>

<style scoped lang="less">
.driver_detial{
  width: 100%;
  .topSearch{
    display: flex;
    .innerSearch{
      margin: 8px;
      width: 20%;
    }
    .topSeach{
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      /deep/ .el-input--prefix .el-input__inner{
        padding-left: 88px;
      }
      /deep/ .el-input__prefix{
        color: #1F2D42;
      }
      .long_search{
        /deep/.el-input__inner{
          padding-left: 115px!important;
        }
      }
      .long_searchs{
        /deep/.el-input__inner{
          padding-left: 133px!important;
        }
      }
      .innerSearch{
        margin: 8px;
        /deep/.el-cascader{
          line-height: 0;
        }
        .innerTime{
          /deep/.el-input__prefix{
            position: absolute;
            top: 0;
            right: 12px;
            left: auto;
          }
          /deep/ .el-input--prefix .el-input__inner{
            padding-left: 12px;
          }
          /deep/.el-input__icon{
            //position: absolute;
            //right: 12px;
            color: #D65953;
          }
        }
        .from{
          /deep/.el-input__inner{
            padding-left: 75px!important;
          }
        }
        .to{
          /deep/.el-input__inner{
            padding-left: 55px!important;
          }
        }
      }
      .cascader{
        position: relative;
        /deep/.el-input__inner{
          padding-left: 80px;
        }
        .slot{
          position: absolute;
          padding-left: 24px;
          font-size: 14px;
          top: 5px;
        }
      }
      .ex{
        width: 300px;
        /deep/ .el-input--prefix .el-input__inner{
          padding-left: 110px;
        }
      }
    }
  }
  .log_table{
    margin-top: 16px;
  }
  .btomPagin{
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    padding-left: 16px;
    .innerLeft{
      font-size: 16px;
      font-family: SFPro-Regular, SFPro;
      font-weight: 400;
      color: #1F2D42;
      line-height: 20px;
    }
  }
}
</style>
